const getters = {
  durationExposure: state => state.durationExposure
};

const mutations = {
  SET_DURATION_EXPOSURE(state, payload) {
    state.durationExposure = payload.durationExposure;
  }
};

const state = {
  durationExposure: {}
};

export default {
  getters,
  mutations,
  state
};
